import { Injectable } from '@angular/core';
import { DataCoreService} from '@dabnet-kamu/libs/ui';
import {GenMahalleCaddeSokakService} from "../ctl-gen-mahalle-cadde-sokak.service";
import { ControlConditionModel } from '../../../../models/gen-control.model';

@Injectable()
export class Service {

    constructor(private dataCoreService: DataCoreService, private genMahalleCaddeSokakService : GenMahalleCaddeSokakService) {}

    getData(control: any,controlCondition:ControlConditionModel[]) {
            const dataSource = this.dataCoreService.getOData(control.dlistMetadata.baseEntity,['GenMahalleKoy','GenCaddeSokak']);
            const filterArr :any[]= [];
              dataSource.select(['Kod','MahalleKod','CaddeSokakKod','GenMahalleKoy.Ad', 'GenCaddeSokak.Ad','AktifEh']);
              if(controlCondition){
                controlCondition.forEach((item:any) => {
                  filterArr.push([item.conditionColName, item.conditionColSymbol, item.conditionColText]);
                });
            }
            if(filterArr.length > 0) dataSource.filter(filterArr);
            // const filterArr = [];
            // if (this.tmsCikisYerService.belediyeCode) filterArr.push(['BelediyeKod', '=', this.tmsCikisYerService.belediyeCode]);
            // if (filterArr.length > 0) dataSource.filter(filterArr);
            return dataSource;
    }

}
